import { logError } from '@/utils/general'

interface DeviceIntelligenceResponse {
  result: {
    session_id: string
  }
}

export const getShieldSessionId = async () => {
  try {
    const { getShield } = useShield()
    const shield = await getShield()
    const res = (await shield.getDeviceIntelligence()) as DeviceIntelligenceResponse

    const sessionId = res.result.session_id

    if (!sessionId) {
      logError(new Error('[shield] shieldSessionId is empty or null'))
    }

    return sessionId
  } catch (error) {
    logError(error, { context: 'getShieldSessionId' })
    return null
  }
}
